import React, { useEffect, useState } from 'react';
import { handleExportClick } from '../../../service/csvExporter';
import axios from 'axios';
import doneLogo from '../../../assets/icondone.svg';
import waitLogo from '../../../assets/iconwait.svg';
import errorLogo from '../../../assets/iconerror.svg';
import downloadLogo from '../../../assets/download.svg';
import publicationLogo from '../../../assets/allPubli.svg';

const url = '/api/publications?pagination=false&isGlobal=true';
const urlCountError = 'count_failed';
const urlPublicationsByStatus = 'publications_by_status';

function Publications() {
    const [published, setPublished] = useState(0);
    const [inProgress, setInProgress] = useState(0);
    const [onError, setOnError] = useState(0);
    const [loading, setLoading] = useState(false);
    const config = {
        headers: {
            'Content-Type': 'application/json',
        },
    };

    async function fetchAllPublications(status?: number) {
        const response = await axios.get(urlPublicationsByStatus + `/${status}`, config);

        return response.data;
    }

    const headers = ['title', 'id', 'message', 'network', 'agencyName'];

    const handleErrorClick = () => {
        handleExportClick(
            headers,
            fetchAllPublications,
            'publications_failed.csv',
            () => setLoading(true),
            () => setLoading(false),
            -1,
        );
    };

    const handlePendingClick = () => {
        handleExportClick(
            headers,
            fetchAllPublications,
            'publications_pending.csv',
            () => setLoading(true),
            () => setLoading(false),
            0,
        );
    };

    const handlePublishedClick = () => {
        handleExportClick(
            headers,
            fetchAllPublications,
            'publications_processed.csv',
            () => setLoading(true),
            () => setLoading(false),
            1,
        );
    };

    useEffect(() => {
        (async () => {
            const response = await axios.get(url, config);

            const countFailed = await axios.get(urlCountError, config);

            let publi = 0;
            let error = countFailed.data.count ?? 0;
            let progress = 0;

            await response.data['hydra:member'].forEach((num: any, index: any) => {
                if (num.status === 2) {
                    publi++;
                }
                if (num.status === 1) {
                    progress++;
                }
            });

            setPublished(publi);
            setInProgress(progress);
            setOnError(error);
        })();
    });

    return (
        <div className="inline-flex flex-col justify-start items-stretch w-[calc(50%-20px)] h-auto rounded bg-white px-[20px] py-[24px] gap-[20px] shadow-lg">
            <div className="flex items-center justify-start gap-2 w-full">
                <img className="h-[40px]" src={publicationLogo} alt="logo publication" />
                <div className="text-neutral-900 text-heavy font-semibold leading-normal">
                    Publications
                </div>
            </div>
            <div className="flex flex-row justify-between">
                <div className="flex flex-col pr-[20px]">
                    <div className="flex flex-col items-start flex-wrap content-start">
                        <img src={doneLogo} alt="logo done" />
                        <span className="text-medium my-[5px]">Publiées</span>
                        <span className="text-heavy font-medium text-dark-gray mb-[5px]">
                            {published}
                        </span>
                        <button
                            className="bg-transparent"
                            onClick={handlePublishedClick}
                            disabled={loading}
                        >
                            <img src={downloadLogo} alt="download logo" />
                        </button>
                    </div>
                </div>
                <div className="flex flex-col pr-[20px]">
                    <div className="flex flex-col items-start flex-wrap content-start">
                        <img src={waitLogo} alt="logo waiting" />
                        <span className="text-medium my-[5px]">En cours</span>
                        <span className="text-heavy font-medium text-dark-gray mb-[5px]">
                            {inProgress}
                        </span>
                        <button
                            className="bg-transparent"
                            onClick={handlePendingClick}
                            disabled={loading}
                        >
                            <img src={downloadLogo} alt="download logo" />
                        </button>
                    </div>
                </div>
                <div className="flex flex-col pr-[20px]">
                    <div className="flex flex-col items-start flex-wrap content-start">
                        <img src={errorLogo} alt="logo error" />
                        <span className="text-medium my-[5px]">En erreur</span>
                        <span className="text-heavy font-medium text-dark-gray mb-[5px]">
                            {onError}
                        </span>
                        <button
                            className="bg-transparent"
                            onClick={handleErrorClick}
                            disabled={loading}
                        >
                            <img src={downloadLogo} alt="download logo" />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Publications;
